var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8641_5507)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 100,
    height: 100,
    rx: 50,
    fill: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8641_5507)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 33,
    width: 44,
    height: 71,
    rx: 4,
    fill: "white",
    fillOpacity: 0.65,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_8641_5507)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 44,
    width: 45,
    height: 57,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 66,
    width: 35,
    height: 5,
    rx: 2.5,
    fill: "#EAEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 74,
    width: 23,
    height: 5,
    rx: 2.5,
    fill: "#EAEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 51,
    width: 13,
    height: 11,
    rx: 1,
    fill: "#EFF0F0"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_8641_5507)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 82.5,
    cy: 44,
    r: 8,
    fill: "#F73C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.48 46.84C84 47.3467 83.3833 47.6 82.63 47.6C81.8767 47.6 81.26 47.3467 80.78 46.84C80.3 46.3267 80.06 45.67 80.06 44.87V43.01C80.06 42.21 80.3 41.5567 80.78 41.05C81.26 40.5367 81.8767 40.28 82.63 40.28C83.3833 40.28 84 40.5367 84.48 41.05C84.9667 41.5567 85.21 42.21 85.21 43.01V44.87C85.21 45.67 84.9667 46.3267 84.48 46.84ZM82.63 46.52C83.0767 46.52 83.4333 46.3733 83.7 46.08C83.9733 45.7867 84.11 45.3833 84.11 44.87V43.01C84.11 42.4967 83.9733 42.0933 83.7 41.8C83.4333 41.5067 83.0767 41.36 82.63 41.36C82.19 41.36 81.8333 41.5067 81.56 41.8C81.2933 42.0933 81.16 42.4967 81.16 43.01V44.87C81.16 45.3833 81.2933 45.7867 81.56 46.08C81.8333 46.3733 82.19 46.52 82.63 46.52Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8641_5507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8338 21.8047L23.713 23.4532L25.3615 24.3325L23.713 25.2117L22.8338 26.8602L21.9545 25.2117L20.306 24.3325L21.9545 23.4532L22.8338 21.8047ZM16.8338 23.888L18.6115 27.2214L21.9449 28.9991L18.6115 30.7769L16.8338 34.1102L15.056 30.7769L11.7227 28.9991L15.056 27.2214L16.8338 23.888ZM24.6115 31.888L23.5005 29.8047L22.3893 31.888L20.306 32.9991L22.3893 34.1102L23.5005 36.1935L24.6115 34.1102L26.6949 32.9991L24.6115 31.888Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8641_5507",
    x: 14.5,
    y: 30,
    width: 52,
    height: 79,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.36 0 0 0 0 0.408 0 0 0 0 0.44 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8641_5507"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8641_5507",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_8641_5507",
    x: 24.5,
    y: 32,
    width: 77,
    height: 89,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.36 0 0 0 0 0.408 0 0 0 0 0.44 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8641_5507"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8641_5507",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_8641_5507",
    x: 70.5,
    y: 34,
    width: 24,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8641_5507"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8641_5507",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8641_5507"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 100,
    height: 100,
    rx: 50,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8641_5507"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(11.5 21)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/empty-state.4dbeea242e2b682918857bfea371e120.svg";
export { ForwardRef as ReactComponent };